import { State, City } from 'country-state-city';
import MicroModal from 'micromodal';
import formCreateBlock from "./blocks/formCreate.js";
import formUpdateBlock from "./blocks/formUpdate.js";
import formNewBlock from "./blocks/formNew.js";

import buttonComponent from './components/button.js'
import formCreateComponent from './components/formCreate.js'
import formUpdateComponent from './components/formUpdate.js'
import cuboFormRowComponent from './components/cuboFormRow.js'
import formNewComponent from './components/formNew.js'

export default (editor, opts = {}) => {

  // const options = {...opts }
  const options = { ...{ State, City, MicroModal }, ...opts }

  // Add components
  editor.DomComponents.addType("cubosuiteButton", buttonComponent(editor, options));
  editor.DomComponents.addType("cubosuiteCreate", formCreateComponent(editor, options));
  editor.DomComponents.addType("cubosuiteUpdate", formUpdateComponent(editor, options));
  editor.DomComponents.addType("cuboFormRow", cuboFormRowComponent(editor, options));
  editor.DomComponents.addType("formNew", formNewComponent(editor, options));

  // Add blocks
  // editor.BlockManager.add("cubosuite-create-block", formCreateBlock(editor, options));
  // editor.BlockManager.add("cubosuite-update-block", formUpdateBlock(editor, options));
  editor.BlockManager.add("new-form-block", formNewBlock(editor, options));
}
